import { render } from "./chargeProspects.vue?vue&type=template&id=119d8602"
import script from "./chargeProspects.vue?vue&type=script&lang=js"
export * from "./chargeProspects.vue?vue&type=script&lang=js"

import "./chargeProspects.vue?vue&type=style&index=0&id=119d8602&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__